import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ImageService from "services/ImageService";

export const generateSingleImageUrl = createAsyncThunk(
  "user/generateSingleImageUrl",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await ImageService.generateSingleImageUrl(data, params);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add user"
      );
    }
  }
);
export const getGenericR2ContentList = createAsyncThunk(
  "user/getGenericR2ContentList",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ImageService.getGenericR2ContentList(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add user"
      );
    }
  }
);
export const editGenericR2Content = createAsyncThunk(
  "user/editGenericR2Content",
  async ({ params, data }, { rejectWithValue }) => {
    try {
      const response = await ImageService.editGenericR2Content(params, data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add user"
      );
    }
  }
);
export const deletGenericR2Content = createAsyncThunk(
  "user/deletGenericR2Content",
  async ({ params, data }, { rejectWithValue }) => {
    try {
      const response = await ImageService.deletGenericR2Content(params, data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add user"
      );
    }
  }
);
const imageSlice = createSlice({
  name: "images",
  initialState: {
    uploadStatus: "idle",
    uploadedImages: [],
    error: null,
    processing: false,
    loading: false,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearUploadedImages: (state) => {
      state.uploadedImages = [];
    },
    setProcessing: (state, action) => {
      state.processing = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateSingleImageUrl.pending, (state) => {
        state.uploadStatus = "loading";
        state.error = null;
        state.loading = true;
      })
      .addCase(generateSingleImageUrl.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadStatus = "succeeded";
        // state.uploadedImages.push(action.payload);
      })
      .addCase(generateSingleImageUrl.rejected, (state, action) => {
        state.loading = false;
        state.uploadStatus = "failed";
        state.error = action.payload;
      })
      .addCase(getGenericR2ContentList.pending, (state) => {
        state.uploadStatus = "loading";
        state.error = null;
        state.loading = true;
        state.uploadedImages = [];
      })
      .addCase(getGenericR2ContentList.fulfilled, (state, action) => {
        state.uploadStatus = "succeeded";
        state.uploadedImages = action.payload;
        state.loading = false;
      })
      .addCase(getGenericR2ContentList.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(editGenericR2Content.pending, (state) => {
        state.uploadStatus = "loading";
        state.error = null;
        state.loading = true;
      })
      .addCase(editGenericR2Content.fulfilled, (state, action) => {
        state.uploadStatus = "succeeded";
        state.uploadedImages = action.payload;
        state.loading = false;
      })
      .addCase(editGenericR2Content.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { clearError, clearUploadedImages, setProcessing } =
  imageSlice.actions;
export default imageSlice.reducer;
